class CharacterCounter {
  constructor(inputText, counterEl = null) {
    this.inputText = inputText;
    this.inputText.addEventListener('input', () => {
      this.count();
    });
    if (!counterEl) {
      const cntContainer = document.createElement('small');
      const cntEl = document.createElement('span');
      cntContainer.className = 'form-text text-muted';
      cntContainer.textContent = `/${this.inputText.getAttribute('maxlength')}`;
      cntContainer.style.display = 'none';
      cntEl.className = 'js-ta-counter';

      cntContainer.insertAdjacentElement('afterbegin', cntEl);
      this.inputText.insertAdjacentElement('afterend', cntContainer);
      this.counterContainer = cntContainer;
      this.conterEl = cntEl;
      this.count();
    }
  }

  count() {
    const charsStat = this.getStat();
    this.emitEvent(charsStat);
    if (this.conterEl) {
      const display = charsStat > 0 ? 'block' : 'none';
      this.conterEl.innerText = charsStat;
      this.counterContainer.style.display = display;
    }
  }

  getStat() {
    return this.inputText.value.trim().length;
  }

  emitEvent(charsStat) {
    const countEvent = new CustomEvent('count', {
      bubbles: true,
      cancelable: true,
      detail: {
        charsStat,
      },
    });

    this.inputText.dispatchEvent(countEvent);
  }
}

export default CharacterCounter;
